const IMAGE_EXTENSIONS = [
  ".png",
  ".bmp",
  ".webp",
  ".jpg",
  ".jpeg",
  ".svg",
] as const;

export function isImageFile(fileName: string): boolean {
  return IMAGE_EXTENSIONS.some((ext) => fileName.toLowerCase().endsWith(ext));
}
